import { Component, Input, OnInit } from '@angular/core';
import { WorkgroupInformationModel } from 'src/app/models/workgroup-information.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IdentityUserService } from 'src/app/services/identityUser.service';
import { IdentityWorkgroupsService } from 'src/app/services/identityWorkgroups.service';
import { LoggingService } from 'src/app/services/logging.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-user-workgroups',
  templateUrl: './user-workgroups.component.html'
})
export class UserWorkgroupsComponent implements OnInit {

  @Input() userGuid!: string;

  workgroups: WorkgroupInformationModel[] = [];
  isOnlyCustomer: boolean = true;
  organisationGuid?: string | null;
  // private _organisation!: Organisation;
  // get organisation(): Organisation {
  //   return this._organisation;
  // }
  // @Input('Organisation') set organisation(val: Organisation) {
  //   this._organisation = val;
  //   if (this._organisation && this._organisation.organisation) {
  //   }
  // }
  constructor(private authenticationService: AuthenticationService, private toastService: ToastService, private userService: IdentityUserService, private workgroupsService: IdentityWorkgroupsService,
    private loggingService: LoggingService) {

  }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe((data) => {
      // we need it to remove
      this.organisationGuid = this.authenticationService.organisationGuid;

      this.isOnlyCustomer = !(data.isOrganisationAdmin || data.isWhitelabelAdmin || data.isSystemAdmin);
      if (this.isOnlyCustomer) {
        this.workgroups = this.authenticationService.currentUserValue.workgroup;
      } else {
        this.getWorkgroups();
      }
    });
  }

  private getWorkgroups() {
    this.userService.getUserWorkgroups(this.userGuid).subscribe({
      error: (error) => {
        this.loggingService.logException(error);
      },
      next: (workgroups: any) => {
        workgroups.forEach((w:any) => {
          let workgroup: WorkgroupInformationModel = {
            Name: w.name ?? w.Name,
            Guid: w.guid ?? w.Guid,
            Clearancelevel: w.clearancelevel ?? w.Clearancelevel
          };
          this.workgroups.push(workgroup);
        });
      }
    });
  }

  async removeWorkgroup(workgroupGuid: string) {
    if (this.organisationGuid == null) {
      return;
    }
    (await this.workgroupsService.deleteMemberWorkgroup(this.organisationGuid!, workgroupGuid, this.userGuid)).subscribe({
      error: () => {
      },
      next: (data: any) => {
        this.toastService.showSaved();
        // also remove it locally
        let workgroupIndex: number = this.workgroups.findIndex((workgroup: WorkgroupInformationModel) => workgroup.Guid === workgroupGuid);
        this.workgroups.splice(workgroupIndex, 1);
      }
    });
  }

}
